export default {
    props: [],
    template: /*html*/`
    <div class="ring-1 ring-black/10 rounded-2xl bg-light">
        <slot></slot>
    </div>
    `
}